import boards from './boards';
import lists from './lists';
import cards from './cards';

export default {
  namespaced: true,
  modules: { boards, lists, cards },
};
